import api from '../api'

export default {

  createGetData: async ()=> {
    return api.get('api/orders/create')
  },

  create: async order => {
    return api.post('api/orders', order)
  },

  repOrders: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/orders/rep-orders?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  process: async (page, take, sortBy, sortOrder, sortBy2, sortOrder2, search, filters) => {
    return api.get(`api/orders/process?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&sort_by_2=${sortBy2}&sort_order_2=${sortOrder2}&search=${search}&filters=${filters}`)
  },

  processUpdate: async (order) => {
    return api.post(`api/orders/process`,order)
  },

  updateGetData: async () => {
    return api.get(`api/orders/update-data`)
  },

  update: async (order) => {
    return api.post(`api/orders/${order.id}/update`,order)
  },

  comment: async (order,comment) => {
    return api.post(`api/orders/${order.id}/comment`,comment)
  },

  commentsRead: async (order,reader) => {
    return api.post(`api/orders/${order.id}/comments/read`,{reader:reader})
  },

  setClerk: async (order) => {
    return api.post(`api/orders/${order.id}/set-clerk`,{})
  },

  enquiry: async (page, take, sortBy, sortOrder, search, filters) => {
    return api.get(`api/orders/enquiry?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

}
